export const LOCALES = ["sv", "no", "en", "da", "fi"] as const;
export type Locale = (typeof LOCALES)[number];

/** BUILD.md §1.2: sv is the default across the product, not en. */
export const DEFAULT_LOCALE: Locale = "sv";

/** `da` and `fi` are scaffolded but untranslated; they fall back to `en` until P12. */
export const TRANSLATED_LOCALES = ["sv", "no", "en"] as const satisfies readonly Locale[];

export function isLocale(value: string): value is Locale {
  return (LOCALES as readonly string[]).includes(value);
}
